import React, {
  createContext,
  memo,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

const AcademicRecordsModalContext = createContext(null);

const INITIAL_STATE = {
  isOpen: false,
  type: null,
  metadata: null,
};

const AcademicRecordsModalProvider = memo(({ children }) => {
  const [state, setState] = useState(INITIAL_STATE);

  const closeModal = useCallback(() => {
    setState(INITIAL_STATE);
  }, []);

  const openModal = useCallback((type, metadata = {}) => {
    setState({ isOpen: true, type, metadata });
  }, []);

  const contextValue = useMemo(
    () => ({ modalInfo: state, openModal, closeModal }),
    [state, openModal, closeModal]
  );

  return (
    <AcademicRecordsModalContext.Provider value={contextValue}>
      {children}
    </AcademicRecordsModalContext.Provider>
  );
});

AcademicRecordsModalProvider.displayName = "AcademicRecordsModalProvider";

const useAcademicRecordsModal = () => useContext(AcademicRecordsModalContext);

export { AcademicRecordsModalProvider, useAcademicRecordsModal };
